import { Chip, Grid, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { MuiButton, MuiPopup, MuiStack } from '../..';
import { WarningCircle } from '../../../assets/images';
import { LOCAL_STORAGE_KEYS, Module, isModuleConfig } from '../../../constants';
import { useAppSelector } from '../../../store/hooks';
import { red } from '../../../theme/palette';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import MapView from './mapView';
export default function RoadTest(props) {
    var isviewOnly = props.isviewOnly, onSkipTest = props.onSkipTest, handleClick = props.handleClick, onClickRoadTestVehicleDetails = props.onClickRoadTestVehicleDetails, onStartTest = props.onStartTest, onClickNext = props.onClickNext, onClickEndTest = props.onClickEndTest, _a = props.isDraftJC, isDraftJC = _a === void 0 ? false : _a, pathCordinates = props.pathCordinates, coveredDistance = props.coveredDistance, timeDuration = props.timeDuration, _b = props.index, index = _b === void 0 ? 0 : _b, onClickMsgIcon = props.onClickMsgIcon, onClickRoadTestTraslate = props.onClickRoadTestTraslate, _c = props.isTestDone, isTestDone = _c === void 0 ? false : _c, isDisabled = props.isDisabled;
    var getModuleHeaderCount = useAppSelector(function (state) { return state.crud; }).getModuleHeaderCount;
    var customerVoiceSectionDetails = useSelector(function (state) { return state.common; }).customerVoiceSectionDetails;
    var isSmallScreen = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var _d = useState(), currentPosition = _d[0], setCurrentPosition = _d[1];
    var _e = useState(false), isOpenSkipTestPopup = _e[0], setIsOpenSkipTestPopup = _e[1];
    var _f = useState(false), isTestStarted = _f[0], setIsTestStarted = _f[1];
    var _g = useState('not started'), roadTestStatus = _g[0], setRoadTestStatus = _g[1];
    var _h = useState(isTestDone), isTestEnd = _h[0], setIsTestEnd = _h[1];
    var _j = useState(0), duration = _j[0], setDuration = _j[1];
    var _k = useState(pathCordinates !== null && pathCordinates !== void 0 ? pathCordinates : []), pathCoordinates = _k[0], setPathCoordinates = _k[1];
    var selectedDesignation = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var _l = useState(false), isLocationEnabled = _l[0], setIsLocationEnabled = _l[1];
    var _m = useState(coveredDistance !== null && coveredDistance !== void 0 ? coveredDistance : null), distance = _m[0], setDistance = _m[1];
    var _o = useState(0), startTestTimeStamp = _o[0], setStartTestTimeStamp = _o[1];
    useEffect(function () {
        getCurrentLocation();
    }, []);
    useEffect(function () {
        getRoadTestDetails();
    }, [pathCordinates, coveredDistance, timeDuration]);
    var getRoadTestDetails = function () {
        if (pathCoordinates)
            setPathCoordinates(pathCordinates);
        if (coveredDistance)
            setDistance(coveredDistance);
        if (timeDuration) {
            setDuration(timeDuration);
            setIsTestEnd(true);
        }
    };
    function convertSecondsToFormattedTime(seconds) {
        // Calculate minutes and remaining seconds
        var minutes = Math.floor(seconds / 60);
        var remainingSeconds = seconds % 60;
        var formattedTime = "".concat(seconds, " Sec");
        if (minutes === 0) {
            formattedTime = "".concat(remainingSeconds, " Sec");
        }
        else {
            formattedTime = "".concat(minutes, " Min ").concat(remainingSeconds, " Sec");
        }
        return formattedTime;
    }
    function getCurrentLocation() {
        return new Promise(function (resolve, reject) {
            // Asynchronous code to get the location
            navigator.geolocation.getCurrentPosition(function (_ref) {
                var _a = _ref.coords, lat = _a.latitude, lng = _a.longitude;
                var pos = {
                    lat: lat,
                    lng: lng
                };
                setCurrentPosition(pos);
                resolve(pos);
                setIsLocationEnabled(true);
            }, function (error) {
                console.error("error", error);
                setIsLocationEnabled(false);
                alert("Geolocation is not enable by your browser.");
            });
        });
    }
    var handleSkipTest = function () {
        setIsOpenSkipTestPopup(true);
    };
    var onCloseSkipTest = function () {
        setIsOpenSkipTestPopup(false);
    };
    var handleConfirm = function () {
        setIsOpenSkipTestPopup(false);
        if (onSkipTest) {
            onSkipTest();
        }
    };
    var onStartOrEndTest = function () {
        if (isTestStarted) {
            setIsTestStarted(false);
            setIsTestEnd(true);
            setRoadTestStatus('ended');
            // clearInterval(timerId)
            // if (onClickEndTest) {
            //     onClickEndTest(duration, distance, path)
            // }
        }
        else {
            // let timer = setInterval(() => {
            //     setDuration((prevState) => prevState + 1)
            // }, 1000);
            // setTimerId(timer)
            setStartTestTimeStamp(+new Date());
            setIsTestStarted(true);
            setRoadTestStatus('started');
            if (onStartTest) {
                onStartTest(currentPosition);
            }
        }
    };
    var handleEndTest = function (distance, path) {
        var timeDiff = moment().diff(moment(startTestTimeStamp), 'seconds');
        setDuration(timeDiff);
        if (onClickEndTest) {
            setDistance(distance);
            console.log("___API DETAILS ", distance, timeDiff, path);
            onClickEndTest(timeDiff, distance, path);
        }
    };
    var handleOnClickNext = function () {
        if (onClickNext) {
            onClickNext();
        }
    };
    var handleClickViewJobs = function () {
        if (onClickRoadTestVehicleDetails) {
            onClickRoadTestVehicleDetails(true);
        }
    };
    var handleMsgClick = function () {
        if (onClickMsgIcon) {
            onClickMsgIcon(true);
        }
    };
    var handleChangePath = function (path) {
        // setPath(path)
    };
    var handleRoadTestTraslate = function () {
        if (onClickRoadTestTraslate) {
            onClickRoadTestTraslate(true);
        }
    };
    var getDistanceFormat = function (distance) {
        if (distance && !Number.isNaN(distance)) {
            if (distance >= 1000) {
                var distanceInKms = distance / 1000;
                return "".concat(distanceInKms.toFixed(2), " KM");
            }
            else {
                return "".concat(distance, " meters");
            }
        }
        else {
            return '0 meters';
        }
    };
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        padding: isDraftJC ? 0 : 0,
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        padding: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        lg: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(MapView, {
        roadTestStatus: roadTestStatus,
        currentPosition: currentPosition,
        endTestHandler: handleEndTest,
        setDistance: setDistance,
        existingCoords: pathCoordinates
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0,
        direction: "column"
    }, (roadTestStatus === 'ended' || roadTestStatus === 'not started') && /*#__PURE__*/ React.createElement(MuiStack, {
        paddingX: 2,
        paddingY: 1,
        justifyContent: "space-between",
        width: "100%",
        bgcolor: "secondary.100"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'base',
            fontWeight: 'normal',
            color: 'text.secondary'
        }
    }, t("Distance"), ": ", " "), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'base',
            fontWeight: 'strong',
            color: 'text.primary'
        }
    }, getDistanceFormat(distance))), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'base',
            fontWeight: 'normal',
            color: 'text.secondary'
        }
    }, t("Duration"), ": ", " "), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'base',
            fontWeight: 'strong',
            color: 'text.primary'
        }
    }, convertSecondsToFormattedTime(parseInt(duration.toFixed()))))), !isTestEnd && !isviewOnly && /*#__PURE__*/ React.createElement(MuiButton, {
        id: "test-ride-start-end-btn",
        variant: "contained",
        size: "medium",
        color: "primary",
        name: isTestStarted ? t("End test") : t("Start test"),
        fullWidth: isSmallScreen,
        onClick: onStartOrEndTest,
        disabled: isDisabled || !isLocationEnabled,
        style: {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            opacity: isDisabled ? 0.7 : 1
        }
    }), (selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) !== "FinalInspector" && /*#__PURE__*/ React.createElement(React.Fragment, null, isTestEnd && !isviewOnly && /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        alignItems: "center",
        paddingY: 0.5,
        paddingX: 1,
        border: "1px solid",
        borderColor: "secondary.200",
        sx: {
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: "8px"
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "translate-to-jobitems-btn",
        name: Module === isModuleConfig.Bajaj ? t('Add more job items') : t('TRANSLATE_TO_JOB_ITEM'),
        variant: "text"
        // style={{ opacity: isDisabled ? 0.7 : 1}}
        ,
        onClick: handleRoadTestTraslate
    }), /*#__PURE__*/ React.createElement(Chip, {
        label: getModuleHeaderCount && (getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.jobItems) || 0,
        color: "primary",
        variant: "filled",
        shape: "circular",
        sx: {
            marginLeft: '10px'
        }
    }))), isviewOnly && /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        alignItems: "center",
        paddingY: 0.5,
        paddingX: 1,
        border: "1px solid",
        borderColor: "secondary.200",
        sx: {
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: "8px"
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "view-jobs-btn",
        name: t('View jobs'),
        variant: "text"
        //style={{ opacity: isDisabled ? 0.7 : 1}}
        ,
        onClick: handleClickViewJobs
    }), /*#__PURE__*/ React.createElement(Chip, {
        label: getModuleHeaderCount ? getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.jobItems : 0,
        color: "primary",
        variant: "filled",
        shape: "circular",
        sx: {
            marginLeft: '10px'
        }
    })))))))), /*#__PURE__*/ React.createElement(MuiPopup, {
        title: t('Warning'),
        openPopup: isOpenSkipTestPopup,
        onClose: onCloseSkipTest,
        variant: "h1",
        subTitle: t("Are you sure you want to skip road test."),
        WarningCircle: WarningCircle,
        padding: '15px'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 7,
        md: 7,
        sm: 7,
        xs: 6,
        sx: {
            display: 'flex',
            justifyContent: 'flex-end'
        }
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "cancel-test-ride-btn",
        variant: "outlined",
        size: "large",
        color: "primary",
        style: {
            borderColor: red
        },
        name: t("Cancel"),
        onClick: onCloseSkipTest
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 5,
        md: 5,
        sm: 5,
        xs: 6,
        sx: {
            display: 'flex',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "confirm-test-ride-btn",
        variant: "contained",
        size: "large",
        color: "primary",
        name: t("Confirm"),
        onClick: handleConfirm
    })))));
}
